<h2 mat-dialog-title>Edit Invoice</h2>
<mat-dialog-content>
  <div [formGroup]="form" class="flex flex-col items-stretch justify-start">
    <mat-form-field>
      <mat-label>Purchase order</mat-label>
      <input
        matInput
        placeholder="Purchase order"
        formControlName="purchase_order"
      />
    </mat-form-field>
    <span class="basis-1/3 pr-4">Invoice Type:</span>
    <mat-radio-group
      formControlName="account"
      class="flex flex-col basis-2/3"
      [required]="true"
    >
      <mat-radio-button class="example-radio-button" [value]="true">
        Account
      </mat-radio-button>
      <mat-radio-button class="example-radio-button" [value]="false">
        Cash
      </mat-radio-button>
    </mat-radio-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button color="primary" mat-button (click)="save()" [disabled]="form.invalid">
    Save
  </button>
</mat-dialog-actions>
